class OTFControlFontStyle {
    container  = '[otf-font-style-control]';
    italic     = '.otf-italic';
    fontWeight = '.otf-font-weight';
    underline  = '.otf-underline';
    uppercase  = '.otf-uppercase';

    constructor() {
        $(`#customize-theme-controls ${this.container}`).each((index, element) => {
            $(`${this.italic}, ${this.fontWeight}, ${this.underline}, ${this.uppercase}`, element).on('change', (event) => {
                this.setValue($(event.currentTarget).closest(this.container));
            })
        })
    }

    setValue($container) {
        let newValue = {
            italic    : $container.find(this.italic).prop('checked'),
            underline : $container.find(this.underline).prop('checked'),
            fontWeight: $container.find(this.fontWeight).prop('checked'),
            uppercase : $container.find(this.uppercase).prop('checked'),
        }
        OTFCustomizeCore.setValue($container, newValue);
    }
}
